import { useEffect } from "react";

const DEFAULT_TITLE = "EOS - ";

/**
 * Sets `document.title` and restores the default title on unmount
 * @param title Custom document title
 */
export function useDocumentTitle(title?: string) {
    useEffect(() => {
        setDocumentTitle(title);

        return () => {
            setDefaultTitle();
        };
    }, [title]);
}

export function setDocumentTitle(title?: string) {
    if (title) {
        document.title = `${DEFAULT_TITLE} ${title}`;
    } else {
        setDefaultTitle();
    }
}

function setDefaultTitle() {
    document.title = DEFAULT_TITLE;
}
